import sum from 'lodash/sum';
import { z } from 'zod';
var rating = z.number().int().min(1).max(5);
var Assessment = z.object({
    feelingShortOfBreath: rating,
    racingHeart: rating,
    feelingDizzy: rating,
    troubleConcentrating: rating
});
export var StressSensitivityAssessment = z.object({
    before: Assessment.optional(),
    after: Assessment.optional()
}).prefault({});
export function getStressSensitivityResult(data) {
    var values = Object.values(data);
    var score = sum(values) / values.length;
    if (score >= 3.6) {
        return {
            score: score,
            result: 'extreme',
            title: 'You have a significant problem with stress sensitivity',
            description: 'Your answers suggest that stress sensitivity is a significant problem area for you, and this program may provide you with better strategies for dealing with stress in the future.'
        };
    } else if (score >= 2.6) {
        return {
            score: score,
            result: 'moderate',
            title: 'You have moderate stress sensitivity',
            description: 'Your answers suggest that you have a definite problem with stress sensitivity, and this program may provide you with healthier ways to cope with stress.'
        };
    } else if (score >= 1.6) {
        return {
            score: score,
            result: 'low',
            title: 'You have some stress sensitivity',
            description: 'Your answers suggest that you have a little stress sensitivity, and this program may provide some helpful tools for managing your stress.'
        };
    }
    return {
        score: score,
        result: 'none',
        title: 'You minimal or no stress sensitivity',
        description: 'Your answers suggest that you don’t have a problem with stress sensitivity, but this program may still be beneficial in preventing the development of it.'
    };
}
export function getStressSensitivityChange(data) {
    if (!data.before || !data.after) return 0;
    var before = getStressSensitivityResult(data.before).score;
    var after = getStressSensitivityResult(data.after).score;
    var reduction = (before - after) / before;
    return reduction;
}
